// eslint-disable-next-line import/no-extraneous-dependencies
import { Box, InputLabel, TextField } from '@mui/material';
import React, { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  onChangeValue: Function;
}

const ContactInfoForm = ({ onChangeValue }: Props) => {
  const { t } = useTranslation();
  return (
    <>
      <InputLabel>{t('NAME')}</InputLabel>
      <TextField
        sx={{
          '& legend': { display: 'none' },
          '& fieldset': { top: 0 }
        }}
        required
        fullWidth
        size="small"
        id="name"
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChangeValue(e)}
      />
      <Box sx={{ height: 20 }}></Box>
      <InputLabel>{t('SURNAME')}</InputLabel>
      <TextField
        sx={{
          '& legend': { display: 'none' },
          '& fieldset': { top: 0 }
        }}
        required
        fullWidth
        size="small"
        id="surname"
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChangeValue(e)}
      />
        <Box sx={{ height: 20 }}></Box>
      <InputLabel>{t('MAIL')}</InputLabel>
      <TextField
        required
        sx={{
          '& legend': { display: 'none' },
          '& fieldset': { top: 0 }
        }}
        fullWidth
        size="small"
        id="mail"
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChangeValue(e)}
      />
        <Box sx={{ height: 20 }}></Box>
      <InputLabel>{t('PHONE')}</InputLabel>
      <TextField
        sx={{
          '& legend': { display: 'none' },
          '& fieldset': { top: 0 }
        }}
        required
        fullWidth
        size="small"
        id="phone"
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChangeValue(e)}
      />
       <Box sx={{ height: 20 }}></Box>
    </>
  );
};

export default ContactInfoForm;
